/** @module csi/heading/DriveFileBrowseController */
define(["dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/ActionView",
	"csi/comm/PostRequest",
	"csi/def/ViewRef",
	"csi/heading/AttributeController",
	"csi/locale",
	"csi/sessionConstants",
], function (declare, lang, ActionView, PostRequest, ViewRef, AttributeController, locale, sessionConstants) {

	return declare(AttributeController, {
		saveResourceId: "BUTTON_UPLOAD",

		/**
		 * @override
		 * Allow only selecting one theme
		 */
		onFormData: function (fd) {
			fd.m_bSelectOne = true;
			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = (ctx, fd) => ctx.getNode().Type === "file";
		},

		/**
		 * Return ActionView for opening Browse from next Cloud view.
		 *
		 * @return {ActionView}
		 */
		getActionView: function (vr) {
			return this.inherited(arguments, [lang.mixin(new ViewRef(), {
				m_url: "centric://SITEADMIN/_CS_CentricDriveFile",
				m_id: "CentricDriveChooseFileView"
			})]);
		},

		/**
		 * @override Publish request to update document file
		 */
		process: function () {
			const selectedNode = this.m_formData.getSelectedNode();
			const req = new PostRequest("DocumentProcessing", "ChangeDocumentCloudFile");
			req.addParameter("URL", this.m_urlNode);
			req.addParameter("OriginalFilePath", selectedNode.RelativePath);
			req.addParameter("ContentType", selectedNode.ContentType);
			req.addParameter("FileId", selectedNode.FileId);
			req.addParameter("Size", selectedNode.Size);
			req.addParameter("SessionURL", sessionConstants.sessionUrl);
			this.waitForPublish(req.post(), true);
		},
	});
});
